"use strict";

angular.module("vendor")
.controller("SectionCatalogsList", function($scope, $state, $stateParams, Catalog) {
    $scope.currentView = "status";
    $scope.pagination = {};

    this.search = function() {
        Catalog.query($stateParams.search, $scope.pagination.current_page).$promise
        .then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.catalogs = data.results;
        });
    };

    this.search();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-list.controller.js
// module id = 979
// module chunks = 0